<template>
  <BittsButton
    v-if="actionText"
    :text="actionText"
    type="neutral"
    variant="outline"
    size="small"
    :left-icon="actionIcon"
    @click="emit('action')"
  />
  <BittsDropdownMenu
    v-if="menuOptions.length"
    :options="menuOptions"
    mode="single"
    :use-search="false"
    @item-click="handleMenuClick"
  >
    <BittsButton
      type="neutral"
      variant="outline"
      size="small"
      :center-icon="['fas', 'ellipsis']"
      :aria-label="`More actions for ${resourceName}`"
    />
  </BittsDropdownMenu>
  <BittsButton
    v-else
    type="neutral"
    variant="outline"
    size="small"
    :center-icon="['fas', 'ellipsis']"
    :aria-label="`More actions for ${resourceName}`"
  />
</template>

<script setup lang="ts">
import { BittsButton, BittsDropdownMenu } from '@crossbeam/bitts';
import type { BittsIcon } from '@crossbeam/bitts';

import type { ApiCardMenuOptionType } from '../types';

const {
  actionText = '',
  actionIcon = undefined,
  menuOptions = [],
} = defineProps<{
  actionText?: string;
  actionIcon?: BittsIcon;
  resourceName: string;
  menuOptions?: ApiCardMenuOptionType[];
}>();

const emit = defineEmits<{
  action: [];
  'menu-select': [value: string];
}>();

function handleMenuClick(option: ApiCardMenuOptionType, event: MouseEvent) {
  event.preventDefault();
  emit('menu-select', option.value);
}
</script>
